module.exports = __webpack_public_path__ + "static/media/2021millerlite.32bfbd21.png";